import { useTranslation } from 'react-i18next';
import { colorsSecondary } from '__app/colors';
import { KizenTypography } from '__app/typography';

export const VariableWarning = () => {
  const { t } = useTranslation();

  return (
    <KizenTypography fontStyle="italic" color={colorsSecondary.red.dark}>
      <br />*
      {t(
        'One of the filters uses automation variables. Blank variable values may result in filter errors which pause automation execution.'
      )}
    </KizenTypography>
  );
};
